const comments = [
  {
    avatar: 'https://readdy.ai/api/search-image?query=Anime%20style%20female%20avatar%20portrait%2C%20soft%20warm%20lighting%2C%20minimalist%20illustration%2C%20gentle%20expression%2C%20clean%20background%2C%20digital%20art%2C%20cute%20girl%20with%20dark%20hair%2C%20simple%20and%20elegant%20style&width=120&height=120&seq=avatar-manga-01&orientation=squarish',
    name: '小樱',
    time: '2小时前',
    content: '女神漫画下拉式真的太方便了！躺在床上刷《社内相亲》，不用一直点翻页，滚动就能看全集，手机看漫画体验天花板！',
    likes: 328,
  },
  {
    avatar: 'https://readdy.ai/api/search-image?query=Anime%20style%20male%20avatar%20portrait%2C%20warm%20lighting%2C%20minimalist%20illustration%2C%20friendly%20expression%2C%20clean%20background%2C%20digital%20art%2C%20boy%20with%20short%20hair%2C%20simple%20modern%20style&width=120&height=120&seq=avatar-manga-02&orientation=squarish',
    name: '追漫达人阿杰',
    time: '5小时前',
    content: '韩漫加日漫都有，还是免费全集，女神漫画下拉式真的是良心平台。《我独自升级》画质也超棒，下拉看战斗场面巨爽！',
    likes: 256,
  },
  {
    avatar: 'https://readdy.ai/api/search-image?query=Anime%20style%20female%20avatar%20portrait%2C%20soft%20lighting%2C%20minimalist%20illustration%2C%20smiling%20expression%2C%20clean%20background%2C%20digital%20art%2C%20girl%20with%20long%20hair%2C%20warm%20and%20friendly%20vibe&width=120&height=120&seq=avatar-manga-03&orientation=squarish',
    name: '漫画控小雨',
    time: '昨天',
    content: '以前在其他站翻页翻到手酸，换了女神漫画下拉式之后彻底回不去了。更新也快，每天都有新内容，推荐给所有漫友！',
    likes: 189,
  },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="py-12 md:py-16 px-4 md:px-6 bg-background-100">
      <div className="max-w-[1400px] mx-auto">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-900">读者评论</h2>
          <p className="text-sm text-foreground-500 mt-2">来自女神漫画下拉式用户的真实反馈</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {comments.map((comment, i) => (
            <div key={i} className="p-5 rounded-xl bg-background-50 border border-background-200/70">
              <div className="flex items-center gap-3 mb-3">
                <div className="w-10 h-10 rounded-full overflow-hidden flex-shrink-0 bg-background-200">
                  <img
                    src={comment.avatar}
                    alt={comment.name}
                    className="w-full h-full object-cover"
                  />
                </div>
                <div className="min-w-0">
                  <p className="text-sm font-medium text-foreground-800">{comment.name}</p>
                  <p className="text-xs text-foreground-400">{comment.time}</p>
                </div>
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed mb-3">
                &ldquo;{comment.content}&rdquo;
              </p>
              <div className="flex items-center gap-1 text-xs text-foreground-400">
                <i className="ri-heart-line text-primary-400"></i>
                <span>{comment.likes}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}